<a routerLink="/">
  <img src="assets/PDlogo_gradient.png" alt="PersonaliDate" />
</a>
